import styled from 'styled-components';

export const FancyTitle = styled.h1`
  font-size: 3.5rem;
  text-align: center;
  color: #2c3e50;
  margin: 2rem 0;
  position: relative;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  letter-spacing: 2px;
  
  &:before {
    content: '';
    position: absolute;
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #ff6b6b, #feca57);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
  }

  &:after {
    content: '';
    position: absolute;
    width: 120px;
    height: 4px;
    background: linear-gradient(90deg, #ff6b6b, #feca57);
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
    opacity: 0.5;
  }

  span {
    background: linear-gradient(90deg, #ff6b6b, #feca57);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    0% {
      filter: brightness(100%);
    }
    50% {
      filter: brightness(120%);
    }
    100% {
      filter: brightness(100%);
    }
  }
`; 